import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToId } from "../lib/scroll";

/**
 * Remonte en haut à chaque changement de route.
 * Si l'URL porte un hash (ex. /#contact depuis une page intérieure),
 * on scrolle vers l'ancre une fois la home montée.
 */
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Saut instantané (et non "smooth") : un scroll animé depuis le haut de la
      // page retarde les reveals au scroll des sections traversées.
      const id = setTimeout(() => scrollToId(hash, "auto"), 120);
      return () => clearTimeout(id);
    }
    window.scrollTo({ top: 0, behavior: "auto" });
    return undefined;
  }, [pathname, hash]);

  return null;
};
